import { Loading } from 'athenaeum';

export default function GlobalLoader() {
  return <Loading icon="ellipsis" messages={['Loading...']} isOpen />;
}
